import { gql } from '@apollo/client';

export const START_QUESTIONNAIRE = gql`
    mutation START_QUESTIONNAIRE($productID: String) {
        startOver(productGroup: $productID) {
            nextQuestionnaire {
                id
                metaData {
                    questionType
                    question
                    questionDesc
                    validationMsg
                }
                answers {
                    id
                    label
                }
            }
            selectedQuestionnaire {
                questionId
                answers {
                    id
                }
            }
            sessionId
            stage
        }
    }
`;

export const SEND_QUESTION_ANSWER = gql`
    mutation SEND_QUESTION_ANSWER(
        $productID: String
        $sessionID: String
        $customerID: String
        $questionID: String
        $answerID: String
    ) {
        pullQuestionnaire(
            request: {
                productGroup: $productID
                sessionId: $sessionID
                customerId: $customerID
                selectedQuestionnaire: [
                    {
                        questionId: $questionID
                        answers: [{ id: $answerID }]
                    }
                ]
            }
        ) {
            productGroup
            nextQuestionnaire {
                id
                metaData {
                    questionType
                    question
                    questionDesc
                    validationMsg
                }
                answers {
                    id
                    value
                    label
                }
            }
            selectedQuestionnaire {
                questionId
                answers {
                    id
                }
            }
            sessionId
            stage
        }
    }
`;
